const questionUrls = {
    fetchQuestions: {
        url: '/question/',
    },
    fetchQuestion: {
        url: '/question/:id'
    },
    fetchFormOptions: {
        url: '/question/actions/formOptions'
    },
    questionHistories: {
        url: '/question/:id/histories'
    },
    fetchQuestionHistory: {
        url: '/question-history/:id'
    }
};
export default questionUrls;
